import * as React from 'react';

import {Button} from 'shells/button/button';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';

type Props = {
    onPrimaryCtaClick: () => void;
};

export function EmptyState(props: Props) {
    return (
        <EmptyStateLarge
            title='This is your newsletters page'
            subtitle='Newsletters and the editions they contain will appear here'
            detailTextBullets={[
                'Use a newsletter for ongoing campaigns, like a monthly or weekly update',
                'Schedule ready-to-send editions for sending at a later date',
                'View edition engagement data and newsletter performance over time',
            ]}
            cta={
                <Button variant='primary' size='big' onClick={props.onPrimaryCtaClick}>
                    Create a newsletter
                </Button>
            }
            icon={
                <img
                    alt=''
                    style={{width: 160, paddingRight: 24}}
                    src='/include/images/empty-states/newsletter.svg'
                />
            }
        />
    );
}
